var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorrectAnswerCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check (4) 6",
    clipPath: "url(#clip0_9956_4999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.97405 13.4571C10.528 13.4571 13.409 10.5658 13.409 6.99928C13.409 3.43275 10.528 0.541504 6.97405 0.541504C3.4201 0.541504 0.539062 3.43275 0.539062 6.99928C0.539062 10.5658 3.4201 13.4571 6.97405 13.4571Z",
    fill: "#6DB188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.9753 14C3.12943 14 0 10.86 0 7C0 3.14051 3.12943 0 6.9753 0C10.8217 0 13.9506 3.14051 13.9506 7C13.9506 10.86 10.8217 14 6.9753 14ZM6.9753 1.08443C3.72484 1.08443 1.0806 3.73803 1.0806 7C1.0806 10.262 3.72484 12.9156 6.9753 12.9156C10.2258 12.9156 12.87 10.2614 12.87 7C12.87 3.73803 10.2258 1.08443 6.9753 1.08443Z",
    fill: "#6DB188"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.13163 9.57494C5.98684 9.57494 5.84851 9.51692 5.74638 9.41282L3.75267 7.37952C3.54358 7.16588 3.54628 6.82321 3.75916 6.61283C3.97204 6.40354 4.31405 6.4057 4.52315 6.61933L6.11597 8.24379L9.41128 4.60175C9.6128 4.37999 9.95429 4.36427 10.1742 4.56489C10.3951 4.76606 10.4114 5.10873 10.2109 5.33103L6.53146 9.39762C6.43152 9.50822 6.29103 9.57221 6.14245 9.57546C6.13866 9.57494 6.13542 9.57494 6.13163 9.57494Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9956_4999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9506,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectAnswerCheck);
export default __webpack_public_path__ + "static/media/correct-answer-check.7d790c5d5ce6d7bb592bbd37b29aa83b.svg";
export { ForwardRef as ReactComponent };